import * as S from './styles';
import { ClientProps, ProductProps } from '@/types';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { OrderItemsProps } from '@/talons/orderStatusPage/useOrderStatusPage';
import { ModalOrderStatus, OrderStatusCard, OrderStatusHeader as Header } from '@/components';
import { getOfflineOrders, getSynchedOrders } from '@/shared';

interface CardProps {
  clientName: string;
  client: ClientProps;
  orders: OrderItemsProps[];
  clientRefNumber: string;
  clientCnpj: string;
  isLast?: boolean;
  date?: string;
  productsDict?: Record<number, ProductProps>;
}

const Card = ({ clientName, orders, clientRefNumber, date, clientCnpj, client }: CardProps) => {
  const [isOpen, setIsOpen] = useState('');

  const toggleModal = useCallback((status: string) => {
    setIsOpen(status);
  }, []);

  const [synchedOrders, setSynchedOrdersState] = useState<any[]>([]);
  const [offlineOrders, setOfflineOrdersState] = useState<any[]>([]);
  useEffect(() => {
    void Promise.all([getSynchedOrders(), getOfflineOrders()]).then(([s, o]) => {
      setSynchedOrdersState(s);
      setOfflineOrdersState(o);
    });
  }, [orders, isOpen]);
  const mappedSynchedOrders = useMemo(() => {
    const map = new Map();
    synchedOrders.forEach((syncOrder: any) => {
      map.set(syncOrder?.orders?.order_number, syncOrder);
    });
    return map;
  }, [synchedOrders]);
  const mappedOfflineOrders = useMemo(() => {
    const map = new Map();
    offlineOrders.forEach((offlineOrder: any) => {
      map.set(offlineOrder?.orders?.order_number, offlineOrder);
    });
    return map;
  }, [offlineOrders]);

  return (
    <S.CardContainer key={`${clientRefNumber}-${clientCnpj}`}>
      <Header client={client} clientName={clientName} clientRefNumber={clientRefNumber} />
      <React.Fragment>
        {orders?.map((order, index) => {
          if (order?.orderDate === date && orders.length > 0) {
            return (
              <div key={`order-content-card-${clientRefNumber}-${clientCnpj}-${index}`}>
                <OrderStatusCard
                  order={order}
                  mappedSynchedOrders={mappedSynchedOrders}
                  mappedOfflineOrders={mappedOfflineOrders}
                  toggleModal={toggleModal}
                  isLast={index === orders?.length - 1}
                  key={`order-status-card-${clientRefNumber}-${clientCnpj}-${index}`}
                />
                <ModalOrderStatus
                  order={order}
                  client={client}
                  clientCnpj={clientCnpj}
                  clientName={clientName}
                  clientRefNumber={clientRefNumber}
                  closeModal={() => toggleModal('')}
                  isOpen={order?.orderNumber === isOpen}
                  clientUnilever={client?.UNILEVER}
                  key={`order-status-modal-${clientRefNumber}-${clientCnpj}-${index}`}
                />
              </div>
            );
          }
          return null;
        })}
      </React.Fragment>
    </S.CardContainer>
  );
};

export default Card;
